/**
 * ENR-1474 Settings → Forms / Form Submissions nav.
 *
 * Enabled after Forms UI shipped to staging. Keep returning true for the
 * staging→main release; delete this helper and inline `true` once stable.
 */
export const isEnrollioFormsNavEnabled = (): boolean => true;
